export default __webpack_public_path__ + "static/media/icon-line.609d3925.svg";